import React from "react";
import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts";
import { thisBaseURL } from "../../utils/helper.js";
require("highcharts/modules/accessibility")(Highcharts);

function EstimatedConsumption({foodAnswers, foodName}){
	let defaultSlug = foodAnswers.answerKeyValues["food_slug"];
	let consumptionData = foodAnswers.answerKeyValues['u_s_consumption_data'];
	let consumptionDataYear = foodAnswers.answerKeyValues['u_s_consumption_data_year'];
	let consumptionDataSourceRef = foodAnswers.answerKeyValues['u_s_consumption_data_sources'];
	let consumptionDataNotes = foodAnswers.answerKeyValues['u_s_consumption_data_notes'];
	let consumptionDataUnit = foodAnswers.answerKeyValues['u_s_consumption_data_unit'] || "Pounds";
	
	let array = [];
	let dataSeries = [];
	let xAxisCategories = [];
	if(consumptionData){
		try {
			array =  JSON.parse(consumptionData);
		} catch (err) {
			console.log("EstimatedConsumption :consumptionData: " +err);
		}
		dataSeries = array.map(function (obj) {
			if(obj && obj["year"] && obj["amount"] ){
				return [parseInt(obj["year"]),parseFloat(obj["amount"])];
			}
		});
		xAxisCategories = array.map(function (obj) {
			if(obj && obj["year"]){
				return [parseInt(obj["year"])];
			}
		});
	}
	let titleText = '';
	if(dataSeries && dataSeries.length > 0 && dataSeries[0]){
		titleText = 'Estimated Consumption of '+foodName+' in the United States per capita '+dataSeries[0][0]+' - '+dataSeries[dataSeries.length - 1][0];
	}
	
	return(
			<div>
				{(dataSeries && dataSeries.length > 0 && dataSeries[0]) ? <><h2 style={{textAlign: "center"}}>
					{titleText}
					{consumptionDataYear ? 
						<small>&nbsp;({consumptionDataYear})</small>
					:""}
					{ consumptionDataSourceRef && consumptionDataSourceRef > 0 ?
					<small className="superscript"><a href={thisBaseURL +"/foods/" +defaultSlug+"#"+consumptionDataSourceRef}>{consumptionDataSourceRef}</a></small>:
					""	
					}
				</h2>
				<HighchartsReact highcharts={Highcharts} containerProps={{ style: { width: "60vw" } }}
				options={{
					title: {
						text: ''
					},
					credits: {
						enabled: false
					},
					lang: {
						thousandsSep: ','
					},
					yAxis: {
						title: {
							text: consumptionDataUnit
						},
						plotLines: [{
							value: 0,
							width: 1,
							color: '#808080'
						}]
					},
					xAxis: {
						categories: xAxisCategories,
						title: {
							text: 'Year'
						}
					},
					legend: {
						enabled: false,
						layout: 'vertical',
						align: 'right',
						verticalAlign: 'middle',
						borderWidth: 0
					},
					series: [{
						name: consumptionDataUnit,
						data: dataSeries
					}]
				}}
				/>
				{consumptionDataNotes  ? 
				<p className="notes-info" style={{marginTop: "auto"}}>
				<em>{consumptionDataNotes}</em>
				</p>
				:""}
				</>:""}
			</div>
		)
}
export default EstimatedConsumption;